import classNames from 'classnames'
import React from 'react'
import { t } from 'shared'
import VisuallyHidden from '../visually_hidden/visually_hidden'
import styles from './progress_indicator.module.css'
import { ProgressIndicatorPropTypes } from './types'

export const ProgressIndicator: React.FC<ProgressIndicatorPropTypes> = ({ steps, currentStep }) => {
  const step = steps[currentStep]
  const text = t('misc.step_m_of_n', { m: currentStep + 1, n: steps.length })
  return (
    <>
      <div role="progressbar" aria-valuetext={text} className={styles.visualContainer}>
        {steps.map((step, index) => (
          <div
            key={index}
            title={step.label}
            className={classNames(styles.item, {
              [styles.itemCurrent]: currentStep === index,
              [styles.itemDone]: currentStep > index,
            })}
          ></div>
        ))}
      </div>
      <VisuallyHidden>{text}</VisuallyHidden>
      {step && <div className={styles.textContainer}>{step.label}</div>}
    </>
  )
}
export default ProgressIndicator
